import React from "react";
import { application } from '~application';

export const wrapPageElement = ({ element }) => {
  const { Providers } = application.components;

  return (
    <Providers application={application}>
      {element}
    </Providers>
  );

};
